/*eslint-disable */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "@rjsf/material-ui";
import { Wrapper } from "./styled";
import {
  getMetadata,
  onFocusField,
  errorHandling,
} from "../../../../../MetadataForm/functions";
import { MuiThemeProvider } from "@material-ui/core/styles";
import {
  documentTypes,
  fileId,
  getfilesByFlowStatus,
  indexing,
} from "../../../../../../../../../store/File/selectors";
import { useStyles, muiTheme } from "./muiStyled";
import ObjectFieldTemplate from "./components/ObjectFieldTemplate";
import { inputCheck, normalize } from "../../../../../../functions";
import { autocomplete } from "../../../../../../../../../store/File/actions";

const MetadataInDetail = (props) => {
  const dispatch = useDispatch();
  const schema = useSelector(documentTypes);
  const fileIndicator = useSelector(fileId);
  const files = useSelector(getfilesByFlowStatus);
  const isIndexing = useSelector(indexing);
  const [formData, setFormData] = useState(files[0].metadata, {});
  const [focusedField, setFocusedField] = useState(null);
  const classes = useStyles(props);

  const onBlur = (event) => {
    dispatch(autocomplete(schema, normalize(event), formData, setFormData));
  };

  const onFocus = (value) => {
    setFocusedField(normalize(value));
    onFocusField(value, schema, formData, setFormData);
  };

  const onChange = (formData) => {
    inputCheck(formData, schema, setFormData, focusedField);
  };

  const transformErrors = (errors) => {
    if (isIndexing) {
      return errorHandling(errors, schema);
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (fileIndicator !== null) {
      setFormData(getMetadata(files, fileIndicator, isIndexing));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileIndicator, files, files.length]);

  if (formData === null) {
    setFormData({});
  }

  return (
    <Wrapper>
      <MuiThemeProvider theme={muiTheme}>
        <Form
          className={classes.root}
          schema={schema}
          uiSchema={{
            "ui:ObjectFieldTemplate": ObjectFieldTemplate,
          }}
          formData={formData}
          onChange={({ formData }) => onChange(formData)}
          onFocus={onFocus}
          onBlur={onBlur}
          showErrorList={false}
          children /*hidden "submit" button*/
          liveValidate
          transformErrors={transformErrors}
        />
      </MuiThemeProvider>
    </Wrapper>
  );
};

export default MetadataInDetail;
